import React, { useEffect, useState } from "react";
import style from "./profile.module.scss";
import Input from "../../Components/input/input"
import Button from "../../Components/Button/button"
import toEnglishNumber from "../../helpers/actions/toEnglishNumber"
import { withRouter } from "react-router-dom"
import EmailRegex from "../../helpers/actions/emailRegex"
import NationalCodeRegex from "../../helpers/actions/nationalCodeRegex"
import { EditProfile, GetUser, ProfileChangePassword } from "../../actions/APIcalls";
import SuccessModal from "./modals/success"
import auth from "../../auth"

const Profile = (props) => {
    const [userId, setUserId] = useState("")
    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    const [phone, setPhone] = useState("")
    const [urgentPhone, seturgentPhone] = useState("")
    const [nationalCode, setNationalCode] = useState("")
    const [prevPassword, setPrevPassword] = useState("")
    const [password, setPassword] = useState("")
    const [data, setData] = useState({ type: "new", editPersnolaInfo: false, editPassword: false })
    const [errors, setErrors] = useState({})
    const [passErrors, setPassErrors] = useState({})
    const [expireDate, setExpireDate] = useState(new Date())
    const [successModal, setSuccessModal] = useState(false)
    const getProfile = async () => {
        setErrors({})
        setPassErrors({})
        let res = await GetUser()
        if (typeof res !== "undefined") {
            let info = res.data.user;
            let da = data
            setUserId(info._id)
            setName(info.name != "مارکیتویی" && info.name != "موبیشایی" ? info.name : "")
            setEmail(info.email ? info.email : '')
            setPhone(info.phone)
            seturgentPhone(info.urgentPhone ? info.urgentPhone : '')
            setNationalCode(info.nationalCode ? info.nationalCode : '')
            setPrevPassword('')
            setPassword('')
            setExpireDate(info.account.wallet.amount > 0 ? 'enough' : 'end')
            if (info.name && info.email && info.phone && info.urgentPhone && info.name != "مارکیتویی" && info.name != "موبیشایی") {
                da.type = "edit"
                da.editPassword = false
                da.editPersnolaInfo = false
                setData({ ...da })
            } else {
                da.type = "new"
                da.editPassword = false
                da.editPersnolaInfo = false
                setData({ ...da })
            }
        }
    }


    const handleEditProfile = async () => {
        if (checkExist('name', name) && EmailValidation() && urgentPhoneValidation() && nationalCodeValidation()) {
            let params = {
                userId: userId,
                name: toEnglishNumber(name),
                email: "",
                urgentPhone: "",
                nationalCode: toEnglishNumber(nationalCode)
            }
            if (email != '') {
                params.email = email
            }
            if (urgentPhone != '') {
                params.urgentPhone = urgentPhone
            }
            let res = await EditProfile(params)
            if (typeof res !== "undefined" && res.data.success) {
                setSuccessModal(true)
                let res = await GetUser()
                auth.setLogin(res.data.user, res.headers.endedpackage, JSON.parse(res.headers.downgradewarning))
                props.renew(res.data.user, res.headers.endedpackage, JSON.parse(res.headers.downgradewarning))

            }
        }
    }

    const EmailValidation = () => {
        if (email != '') {
            if (EmailRegex(email)) {
                let errs = errors
                delete errs['email']
                setErrors({ ...errs })
                return true
            } else {
                let errs = errors
                errs['email'] = "ایمیل وارد شده معتبر نیست!"
                setErrors({ ...errs })
                return false
            }
        } else {
            return true
        }
    }

    const urgentPhoneValidation = () => {
        if (urgentPhone) {
            if (phone !== urgentPhone) {
                let errs = errors
                delete errs['urgentPhone']
                setErrors({ ...errs })
                return true
            } else {
                let errs = errors
                errs['urgentPhone'] = "شماره‌ی تماس ضروری باید متفاوت از شماره کاربر باشد!"
                setErrors({ ...errs })
            }
        } else return true
    }

    const nationalCodeValidation = () => {
        if (nationalCode != '') {
            if (NationalCodeRegex(nationalCode)) {
                let errs = errors
                delete errs['nationalCode']
                setErrors({ ...errs })
                return true
            } else {
                let errs = errors
                errs['nationalCode'] = "کدملی وارد شده معتبر نیست"
                setErrors({ ...errs })
                return false
            }
        } else {
            let errs = errors
            errs['nationalCode'] = "تکمیل  این فیلد الزامیست!"
            setErrors({ ...errs })
            return false
        }
    }

    const checkExist = (propertyName, value) => {
        let errs = errors
        if (value) {
            return true
        } else {
            errs[propertyName] = "تکمیل  این فیلد الزامیست!"
            setErrors({ ...errs })
            return false
        }
    }

    const checkPasswordExist = (propertyName) => {
        let errs = passErrors
        if (propertyName) {
            return true
        } else {
            errs[propertyName] = "تکمیل  این فیلد الزامیست!"
            setPassErrors({ ...errs })
            return false
        }
    }

    const handleInput = (tag, e) => {
        let da = data
        if (tag == 'name') {
            setName(e.target.value)
            da.editPersnolaInfo = true
            setData({ ...da })
        }
        if (tag == 'email') {
            setEmail(e.target.value)
            da.editPersnolaInfo = true
            setData({ ...da })
        }
        if (tag == 'urgentPhone') {
            seturgentPhone(toEnglishNumber(e.target.value))
            da.editPersnolaInfo = true
            setData({ ...da })
        }
        if (tag == 'nationalCode') {
            setNationalCode(toEnglishNumber(e.target.value))
            da.editPersnolaInfo = true
            setData({ ...da })
        }
        if (tag == 'prevPassword') {
            setPrevPassword(e.target.value)
            da.editPassword = true
            setData({ ...da })
        }
        if (tag == 'password') {
            setPassword(e.target.value)
            da.editPassword = true
            setData({ ...da })
        }
    }

    const handleChangePassword = async () => {
        if (checkPasswordExist(prevPassword) && checkPasswordExist(password)) {
            let params = {
                userId: userId,
                phone: phone,
                prevPassword: toEnglishNumber(prevPassword),
                newPassword: toEnglishNumber(password),
            }
            let res = await ProfileChangePassword(params)
            if (typeof res !== "undefined") {
                if (typeof res.data !== "undefined" && res.data.success) {
                    setSuccessModal(true)
                    setPassword('')
                    setPrevPassword('')
                    getProfile()
                } else {
                    if (typeof res.response !== "undefined" && res.response.status && res.response.status == 416) {
                        alert('رمز عبور قبلی اشتباه است!')
                        let errs = errors
                        errs['prevPassword'] = 'رمز عبور قبلی اشتباه است!'
                        setErrors({ ...errs })
                    }
                }
            }
        }
    }

    const handleBlure = () => {
        /** Do Nothing */
    }

    useEffect(() => {
        getProfile()
    }, []);

    return (
        <div>
            <SuccessModal
                successValue={successModal}
                CloseModal={() => setSuccessModal(!successModal)}
                confirmSuccess={() => setSuccessModal(!successModal)}
            />
            <div className={style.profileFrame}>

                <h1 className={style.profileTitle}>پروفایل</h1>
                <div className={expireDate == 'end' ? style.warning : style.greenWarning}>
                    <span className={style.warningIcon}>h</span>
                    {expireDate == 'end'
                        ?
                        <p>شارژ کیف پول شما به پایان رسیده‌است.</p>
                        :
                        <p>شارژ کیف پول شما برای قیمت‌گذاری کافی است.</p>
                    }
                    <p onClick={() => props.history.push('/chargewallet')} className={style.renewPackage}>شارژ کیف پول</p>
                </div>
                <div className={style.profileInformationFrame}>
                    <h2 className={style.profileInformationTitle}>اطلاعات شخصی</h2>
                    <div className={style.profileInformationInner}>
                        <div className={style.inputFrame}>
                            <Input
                                label="نام و نام خانوادگی"
                                secondTag='name'
                                type="text"
                                disabled={false}
                                placeholder="نام و نام خانوادگی"
                                tag="name"
                                value={name}
                                error={errors['name']}
                                onchange={handleInput}
                                onblur={handleBlure}
                            />
                        </div>
                        <div className={style.inputFrame}>
                            <Input
                                label="کدملی"
                                secondTag='nationalCode'
                                type="text"
                                disabled={false}
                                placeholder="کدملی"
                                tag="nationalCode"
                                value={nationalCode}
                                error={errors['nationalCode']}
                                onchange={handleInput}
                                onblur={handleBlure}
                            />
                        </div>
                        <div className={style.inputFrame}>
                            <input type="text" name="email" placeHolder='ایمیل' style={{ display: 'none' }} />
                            <Input
                                label="ایمیل"
                                secondTag='email'
                                type="text"
                                disabled={false}
                                placeholder='ایمیل'
                                tag="email"
                                value={email}
                                error={errors['email']}
                                onchange={handleInput}
                                onblur={handleBlure}
                            />
                        </div>
                        <div className={style.inputFrame}>
                            <Input
                                label="شماره تماس"
                                secondTag='phone'
                                type="text"
                                disabled={true}
                                placeholder="شماره تماس"
                                tag="phone"
                                value={phone}
                                error=''
                                onchange={handleInput}
                                onblur={handleBlure}
                            />
                        </div>
                        <div className={style.inputFrame}>
                            <input type="text" name="urgentPhone" placeHolder="شماره تماس ضروری"
                                style={{ display: 'none' }} />
                            <Input
                                label="شماره تماس ضروری"
                                secondTag='urgentPhone'
                                type="text"
                                disabled={false}
                                placeholder="شماره تماس ضروری"
                                tag="urgentPhone"
                                value={urgentPhone}
                                error={errors['urgentPhone']}
                                tooltip={"شماره تلفن همراه و یا شماره ثابت به همراه کد شهر"}
                                onchange={handleInput}
                                onblur={handleBlure}
                            />
                        </div>
                        <div className={style.inputFrame}></div>
                        <div className={style.inputFrame}>
                            <div className={style.buttonWrapper}>
                                <Button
                                    disabled={!data.editPersnolaInfo}
                                    tag="edit"
                                    type="solid"
                                    label={data.type === "edit" ? " ویرایش" : "ثبت اطلاعات"}
                                    onclick={handleEditProfile}
                                />
                            </div>
                            <div className={style.buttonWrapper}>
                                <Button
                                    disabled={!data.editPersnolaInfo}
                                    tag="cancelEditInfo"
                                    type="outline"
                                    label="انصراف"
                                    onclick={() => {
                                        getProfile()
                                    }}
                                />
                            </div>
                        </div>
                        <div className={style.inputFrame}>

                        </div>
                    </div>
                </div>

                <div className={style.profileInformationFrame}>
                    <h2 className={style.profileInformationTitle}>رمز عبور</h2>
                    <div className={style.profileInformationInner}>
                        <div className={style.inputFrame}>
                            <Input
                                label="رمز عبور قبلی"
                                secondTag='prevPassword'
                                type="password"
                                disabled={false}
                                placeholder="رمز عبور قبلی"
                                tag="prevPassword"
                                value={prevPassword}
                                error={passErrors[prevPassword]}
                                onchange={handleInput}
                                onblur={handleBlure}
                            />
                        </div>
                        <div className={style.inputFrame}>
                            <Input
                                label="رمز عبور جدید"
                                // tag='newPassword'
                                type="password"
                                disabled={false}
                                placeholder="رمز عبور جدید"
                                tag="password"
                                value={password}
                                error={passErrors[password]}
                                onchange={handleInput}
                                onblur={handleBlure}
                            />
                        </div>
                        <div className={style.inputFrame}>
                            <div className={style.buttonWrapper}>
                                <Button
                                    disabled={!data.editPassword}
                                    tag="editPassword"
                                    type="solid"
                                    label="ویرایش رمز عبور"
                                    onclick={handleChangePassword}
                                />
                            </div>
                            <div className={style.buttonWrapper}>
                                <Button
                                    disabled={!data.editPassword}
                                    tag="cancel"
                                    type="outline"
                                    label="انصراف"
                                    onclick={() => {
                                        getProfile()
                                    }}
                                />
                            </div>
                        </div>
                        <div className={style.inputFrame}>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    )

}

export default withRouter(Profile);
